// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2Ld-c","content":"RecentSearches_content__ySjEF"};